export const translations = {
  it: {
    nav: {
      mission: "Chi siamo",
      services: "Servizi",
      structures: "Strutture",
      careers: "Lavora con noi",
      contacts: "Contatti",
    },
    hero: {
      eyebrow: "Società Cooperativa Sociale · Accoglienza Minori",
      line1: "Ogni bambino",
      line2: "merita un luogo",
      line3: "da chiamare casa.",
      sub: "Filia accoglie minori in quattro comunità educative tra Campania e Lazio: ambienti familiari, educatori qualificati e percorsi di crescita costruiti su misura per ogni ragazzo.",
      ctaPrimary: "Scopri le strutture",
      ctaSecondary: "La nostra missione",
      stat1: "4 comunità educative",
      stat2: "2 regioni, 4 province",
      stat3: "Accoglienza 365 giorni l'anno",
      badge: "Cura, ogni giorno",
    },
    manifesto: {
      eyebrow: "Il nostro manifesto",
      title: "Chi siamo",
      intro: "La filia (in greco antico φιλία, philía) significa amicizia, affetto fraterno o amore disinteressato. È un legame profondo basato su stima, fiducia e affinità spirituale, che si differenzia dall'amore passionale (eros) e da quello incondizionato (agape). Da questo valore nasce il nostro nome e il nostro impegno quotidiano. Filia è una società cooperativa sociale nata per dare risposte concrete all'accoglienza dei minori. Il nostro lavoro è affidato a un'équipe multidisciplinare di diverse figure professionali — educatori, psicologi, operatori socio-sanitari e assistenti sociali — tutte altamente preparate e in costante formazione. Le nostre comunità sono aperte 365 giorni l'anno, 24 ore su 24: perché la cura non va mai in pausa. Quattro capitoli, un unico impegno.",
      chapters: [
        {
          num: "01",
          title: "Accoglienza",
          text: "Apriamo le porte a chi ne ha più bisogno. Ogni minore che entra nelle nostre comunità trova un ambiente sicuro, caldo e protetto, dove poter finalmente abbassare le difese e tornare a essere bambino. Ma l'accoglienza è anche un patto: fatto di regole condivise, di rispetto per sé e per gli altri, di fiducia costruita giorno dopo giorno. È da queste basi solide che comincia ogni vero percorso di crescita.",
        },
        {
          num: "02",
          title: "Educazione",
          text: "Educatori professionali accompagnano ogni ragazzo in un percorso individualizzato: scuola, emozioni, relazioni. La formazione è il cuore del nostro lavoro quotidiano: significa studio e preparazione, ma anche imparare a vivere insieme, a rispettare i tempi e gli spazi comuni, a riconoscere il valore dell'altro. Perché educare non è riempire un vuoto, ma accendere una possibilità.",
        },
        {
          num: "03",
          title: "Comunità",
          text: "Le nostre case sono famiglie. Si condividono i pasti, le feste e le piccole responsabilità quotidiane: è nella vita di ogni giorno che si impara a stare al mondo. In comunità ognuno conta e ognuno fa la sua parte, perché la fratellanza non si insegna a parole: si vive, tra regole chiare, gesti di cura reciproca e il rispetto di chi ci sta accanto.",
        },
        {
          num: "04",
          title: "Futuro",
          text: "La meta è l'autonomia: restituire a ogni giovane gli strumenti per costruire il proprio domani. Prepariamo i ragazzi al mondo del lavoro e all'indipendenza con percorsi di formazione, tirocini e life skills, perché possano affrontare la vita adulta con competenza, dignità e rispetto di sé. Che sia il rientro in famiglia o una vita indipendente, nessuno riparte da zero.",
        },
      ],
    },
    marquee: ["Accoglienza", "Educazione", "Cura", "Comunità", "Futuro", "Famiglia"],
    services: {
      eyebrow: "Cosa facciamo",
      title: "I nostri servizi",
      sub: "Un'offerta integrata che accompagna ogni minore in tutte le dimensioni della sua crescita.",
      items: [
        {
          title: "Accoglienza residenziale",
          text: "Comunità educative residenziali aperte 365 giorni l'anno, con équipe qualificate presenti giorno e notte. Ogni ospite trova una casa vera, con regole chiare e condivise, dove sentirsi al sicuro e imparare il rispetto di sé, degli altri e degli spazi comuni.",
        },
        {
          title: "Supporto educativo",
          text: "Progetti educativi individualizzati costruiti sulle potenzialità di ogni ragazzo: accompagnamento scolastico quotidiano, recupero della motivazione e tutoraggio. Perché la formazione è il primo strumento di riscatto e di libertà.",
        },
        {
          title: "Sostegno psicologico",
          text: "Spazi di ascolto protetti e supporto emotivo con professionisti dedicati. Lavoriamo sulle ferite, ma anche sulle risorse: autostima, gestione delle emozioni e rispetto di sé sono le fondamenta di ogni percorso di crescita.",
        },
        {
          title: "Inclusione sociale",
          text: "Attività sul territorio, sport, laboratori e volontariato per costruire relazioni positive e senso di appartenenza. Nel gruppo si impara la fratellanza: stare con gli altri, rispettarli e sentirsi parte di qualcosa di più grande.",
        },
        {
          title: "Autonomia e futuro",
          text: "Percorsi concreti verso l'indipendenza: orientamento, formazione professionale, tirocini e life skills, dalla gestione del denaro alla cura della casa. Prepariamo ogni giovane al mondo del lavoro e alla vita adulta, un passo alla volta.",
        },
        {
          title: "Tutela e protezione",
          text: "Un ambiente protetto, nel pieno rispetto dei diritti e della dignità di ogni minore accolto. Lavoriamo in rete con servizi sociali, Tribunale e famiglie, con un unico obiettivo: il superiore interesse del minore.",
        },
      ],
    },
    structures: {
      eyebrow: "Dove siamo",
      title: "Le nostre strutture",
      sub: "Quattro comunità educative tra Campania e Lazio, ognuna con la sua storia e la sua anima.",
      items: [
        {
          name: "Succivo",
          province: "CE",
          region: "Campania",
          address: "Piazza IV Novembre · Succivo (CE)",
          text: "Comunità educativa residenziale inserita in un antico e prestigioso cortile nel cuore di Succivo.",
        },
        {
          name: "Orta di Atella",
          province: "CE",
          region: "Campania",
          address: "Via San Donato, 62 · Orta di Atella (CE)",
          text: "Una struttura ospitata in un antico e prestigioso cortile, nel centro di Orta di Atella.",
        },
        {
          name: "Villa Santa Lucia",
          province: "FR",
          region: "Lazio",
          address: "Via Amedeo, 35 · Villa Santa Lucia (FR)",
          text: "Una struttura circondata dalla natura ciociara, tra storia e quiete.",
        },
        {
          name: "San Gennaro Vesuviano",
          province: "NA",
          region: "Campania",
          address: "Via Ottaviano, 51 · San Gennaro Vesuviano (NA)",
          text: "Una comunità alle pendici del Vesuvio, aperta al territorio.",
        },
      ],
    },
    map: {
      eyebrow: "Le sedi",
      title: "Dove trovarci",
      sub: "La sede legale a Villaricca e le quattro comunità educative tra Campania e Lazio.",
      hqLabel: "Sede legale",
      hqAddress: "Via della Repubblica, 41 · 80010 Villaricca (NA)",
      directions: "Indicazioni stradali",
    },
    contact: {
      eyebrow: "Contatti",
      title: "Scrivici.",
      sub: "Compila il modulo: la tua richiesta arriverà direttamente alla nostra segreteria e ti risponderemo al più presto.",
      nameLabel: "Nome e cognome",
      namePlaceholder: "Mario Rossi",
      emailLabel: "Email",
      emailPlaceholder: "mario.rossi@email.it",
      phoneLabel: "Telefono (facoltativo)",
      phonePlaceholder: "+39 ...",
      subjectLabel: "Oggetto",
      subjectPlaceholder: "Seleziona un oggetto",
      subjectOptions: ["Richiesta di accoglienza", "Collaborazione", "Lavora con noi", "Altro"],
      messageLabel: "Messaggio",
      messagePlaceholder: "Scrivi qui la tua richiesta...",
      submit: "Invia richiesta",
      sending: "Invio in corso...",
      success: "Messaggio inviato! Ti risponderemo al più presto.",
      error: "Errore nell'invio. Riprova o scrivici a cooperativafilia@gmail.com",
      consentText: "Ho letto l'informativa privacy e acconsento al trattamento dei miei dati personali.",
    },
    careers: {
      eyebrow: "Lavora con noi",
      title: "Entra nella nostra équipe.",
      sub: "Cerchiamo educatori professionali, psicologi e operatori socio-sanitari che condividano i nostri valori: rispetto, regole e fratellanza. Invia la tua candidatura e allega il curriculum: ti ricontatteremo appena si apre una posizione.",
      roleLabel: "Ruolo per cui ti candidi",
      rolePlaceholder: "Seleziona un ruolo",
      roles: ["Educatore professionale", "Psicologo/a", "Operatore socio-sanitario", "Altro"],
      cvLabel: "Curriculum (PDF o DOC, max 5 MB)",
      cvButton: "Allega il tuo CV",
      cvSelected: "File selezionato:",
      cvInvalid: "Formato non valido: usa PDF, DOC o DOCX (max 5 MB).",
      submit: "Invia candidatura",
      sending: "Invio in corso...",
      success: "Candidatura inviata! Ti ricontatteremo presto.",
      error: "Errore nell'invio. Riprova o scrivici a cooperativafilia@gmail.com",
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Ultimo aggiornamento: agosto 2026",
      back: "Torna alla home",
      sections: [
        { title: "1. Titolare del trattamento", text: "Il titolare del trattamento dei dati personali è Filia Società Cooperativa Sociale, con sede legale in Via della Repubblica, 41 – 80010 Villaricca (NA), P.IVA 10250451217. Contatti: cooperativafilia@gmail.com · PEC: cooperativafilia@pec.it · Tel. +39 081 1966 3532." },
        { title: "2. Dati raccolti", text: "Attraverso i moduli presenti sul sito raccogliamo esclusivamente i dati forniti volontariamente dall'utente: nome, indirizzo email, numero di telefono (facoltativo), contenuto del messaggio e, per le candidature, il curriculum vitae allegato. Non utilizziamo cookie di profilazione né strumenti di tracciamento di terze parti." },
        { title: "3. Finalità e base giuridica", text: "I dati inviati tramite il modulo contatti sono trattati per rispondere alle richieste ricevute. I dati e i curriculum inviati tramite la sezione \"Lavora con noi\" sono trattati per valutare le candidature. La base giuridica del trattamento è il consenso dell'interessato (art. 6, par. 1, lett. a GDPR), espresso tramite l'apposita casella di spunta." },
        { title: "4. Conservazione dei dati", text: "I dati di contatto sono conservati per il tempo necessario a gestire la richiesta. I curriculum sono conservati per un massimo di 24 mesi dall'invio, salvo diversa richiesta dell'interessato, e successivamente eliminati." },
        { title: "5. Comunicazione a terzi", text: "I dati non sono venduti né ceduti a terzi. Sono trattati esclusivamente dal personale autorizzato della cooperativa e dai fornitori tecnici (hosting e servizio email) che operano nel rispetto del GDPR." },
        { title: "6. Diritti dell'interessato", text: "In qualsiasi momento puoi esercitare i diritti previsti dagli artt. 15-22 del GDPR (accesso, rettifica, cancellazione, limitazione, opposizione, portabilità) scrivendo a cooperativafilia@gmail.com. Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it)." },
      ],
    },
    footer: {
      title: "Parliamone.",
      sub: "Per segnalazioni, collaborazioni o richieste di accoglienza, scrivici o chiamaci: ti risponderemo al più presto.",
      emailLabel: "Email",
      pecLabel: "PEC",
      phoneLabel: "Telefono",
      hqLabel: "Sede legale",
      vatLabel: "P.IVA",
      vatValue: "10250451217",
      hqValue: "Via della Repubblica, 41 · 80010 Villaricca (NA)",
      rights: "© 2026 Filia Società Cooperativa Sociale — Tutti i diritti riservati",
      tagline: "Accoglienza minori · Campania e Lazio",
    },
  },
  en: {
    nav: {
      mission: "About us",
      services: "Services",
      structures: "Facilities",
      careers: "Work with us",
      contacts: "Contact",
    },
    hero: {
      eyebrow: "Social Cooperative · Residential Care for Minors",
      line1: "Every child",
      line2: "deserves a place",
      line3: "to call home.",
      sub: "Filia welcomes minors in four educational communities across Campania and Lazio: family-like environments, qualified educators and growth paths tailored to every young person.",
      ctaPrimary: "Explore our facilities",
      ctaSecondary: "Our mission",
      stat1: "4 educational communities",
      stat2: "2 regions, 4 provinces",
      stat3: "Care 365 days a year",
      badge: "Care, every day",
    },
    manifesto: {
      eyebrow: "Our manifesto",
      title: "Who we are",
      intro: "Philia (in ancient Greek φιλία, philía) means friendship, fraternal affection or selfless love. It is a deep bond based on esteem, trust and spiritual affinity, distinct from passionate love (eros) and unconditional love (agape). This value is where our name and our daily commitment come from. Filia is a social cooperative founded to provide concrete answers in residential care for minors. Our work is entrusted to a multidisciplinary team of different professionals — educators, psychologists, social care workers and social workers — all highly qualified and in continuous training. Our communities are open 365 days a year, 24 hours a day: because care never takes a break. Four chapters, one commitment.",
      chapters: [
        {
          num: "01",
          title: "Welcome",
          text: "We open our doors to those who need it most. Every minor entering our communities finds a safe, warm and protected environment, where they can finally let their guard down and be a child again. But welcome is also a pact: made of shared rules, respect for oneself and for others, and trust built day after day. Every true path of growth starts from these solid foundations.",
        },
        {
          num: "02",
          title: "Education",
          text: "Professional educators guide every young person along an individual path: school, emotions, relationships. Learning is at the heart of our daily work: it means study and preparation, but also learning to live together, to respect shared times and spaces, and to recognise the value of others. Because to educate is not to fill a void, but to light a possibility.",
        },
        {
          num: "03",
          title: "Community",
          text: "Our houses are families. Meals, celebrations and small daily responsibilities are shared: it is in everyday life that we learn how to be in the world. In our communities everyone matters and everyone plays their part, because brotherhood is not taught in words: it is lived, through clear rules, gestures of mutual care and respect for those around us.",
        },
        {
          num: "04",
          title: "Future",
          text: "The goal is autonomy: giving every young person the tools to build their own tomorrow. We prepare our guests for the world of work and independence through training, internships and life skills, so they can face adult life with competence, dignity and self-respect. Whether returning to their family or starting an independent life, no one starts from zero.",
        },
      ],
    },
    marquee: ["Welcome", "Education", "Care", "Community", "Future", "Family"],
    services: {
      eyebrow: "What we do",
      title: "Our services",
      sub: "An integrated offer supporting every minor in every dimension of their growth.",
      items: [
        {
          title: "Residential care",
          text: "Residential educational communities open 365 days a year, with qualified teams present day and night. Every guest finds a real home, with clear shared rules, where they can feel safe and learn respect for themselves, for others and for common spaces.",
        },
        {
          title: "Educational support",
          text: "Individual educational projects built on each young person's potential: daily school support, motivation recovery and tutoring. Because education is the first tool of redemption and freedom.",
        },
        {
          title: "Psychological support",
          text: "Protected listening spaces and emotional support with dedicated professionals. We work on wounds, but also on resources: self-esteem, emotional management and self-respect are the foundations of every growth path.",
        },
        {
          title: "Social inclusion",
          text: "Local activities, sports, workshops and volunteering to build positive relationships and a sense of belonging. In a group you learn brotherhood: being with others, respecting them and feeling part of something bigger.",
        },
        {
          title: "Autonomy and future",
          text: "Concrete paths towards independence: guidance, vocational training, internships and life skills, from managing money to caring for a home. We prepare every young person for the world of work and adult life, one step at a time.",
        },
        {
          title: "Care and protection",
          text: "A protected environment, with full respect for the rights and dignity of every minor we welcome. We work in network with social services, courts and families, with one goal: the best interest of the child.",
        },
      ],
    },
    structures: {
      eyebrow: "Where we are",
      title: "Our facilities",
      sub: "Four educational communities between Campania and Lazio, each with its own story and soul.",
      items: [
        {
          name: "Succivo",
          province: "CE",
          region: "Campania",
          address: "Piazza IV Novembre · Succivo (CE)",
          text: "A residential educational community set within an ancient and prestigious courtyard in the heart of Succivo.",
        },
        {
          name: "Orta di Atella",
          province: "CE",
          region: "Campania",
          address: "Via San Donato, 62 · Orta di Atella (CE)",
          text: "A facility housed in an ancient and prestigious courtyard, in the centre of Orta di Atella.",
        },
        {
          name: "Villa Santa Lucia",
          province: "FR",
          region: "Lazio",
          address: "Via Amedeo, 35 · Villa Santa Lucia (FR)",
          text: "A facility surrounded by the nature of Ciociaria, between history and quiet.",
        },
        {
          name: "San Gennaro Vesuviano",
          province: "NA",
          region: "Campania",
          address: "Via Ottaviano, 51 · San Gennaro Vesuviano (NA)",
          text: "A community on the slopes of Mount Vesuvius, open to its territory.",
        },
      ],
    },
    map: {
      eyebrow: "Our locations",
      title: "Where to find us",
      sub: "The registered office in Villaricca and the four educational communities between Campania and Lazio.",
      hqLabel: "Registered office",
      hqAddress: "Via della Repubblica, 41 · 80010 Villaricca (NA), Italy",
      directions: "Get directions",
    },
    contact: {
      eyebrow: "Contact",
      title: "Write to us.",
      sub: "Fill in the form: your request will go straight to our office and we will reply as soon as possible.",
      nameLabel: "Full name",
      namePlaceholder: "John Smith",
      emailLabel: "Email",
      emailPlaceholder: "john.smith@email.com",
      phoneLabel: "Phone (optional)",
      phonePlaceholder: "+39 ...",
      subjectLabel: "Subject",
      subjectPlaceholder: "Select a subject",
      subjectOptions: ["Placement request", "Collaboration", "Work with us", "Other"],
      messageLabel: "Message",
      messagePlaceholder: "Write your request here...",
      submit: "Send request",
      sending: "Sending...",
      success: "Message sent! We will reply as soon as possible.",
      error: "Sending failed. Please retry or write to cooperativafilia@gmail.com",
      consentText: "I have read the privacy policy and consent to the processing of my personal data.",
    },
    careers: {
      eyebrow: "Work with us",
      title: "Join our team.",
      sub: "We are looking for professional educators, psychologists and social care workers who share our values: respect, rules and brotherhood. Send your application with your CV: we will get back to you as soon as a position opens.",
      roleLabel: "Role you are applying for",
      rolePlaceholder: "Select a role",
      roles: ["Professional educator", "Psychologist", "Social care worker", "Other"],
      cvLabel: "Resume (PDF or DOC, max 5 MB)",
      cvButton: "Attach your CV",
      cvSelected: "Selected file:",
      cvInvalid: "Invalid format: use PDF, DOC or DOCX (max 5 MB).",
      submit: "Send application",
      sending: "Sending...",
      success: "Application sent! We will get back to you soon.",
      error: "Sending failed. Please retry or write to cooperativafilia@gmail.com",
    },
    privacy: {
      title: "Privacy Policy",
      updated: "Last updated: August 2026",
      back: "Back to home",
      sections: [
        { title: "1. Data controller", text: "The data controller is Filia Società Cooperativa Sociale, registered office Via della Repubblica, 41 – 80010 Villaricca (NA), Italy, VAT no. 10250451217. Contacts: cooperativafilia@gmail.com · Certified email (PEC): cooperativafilia@pec.it · Tel. +39 081 1966 3532." },
        { title: "2. Data we collect", text: "Through the forms on this site we only collect data voluntarily provided by the user: name, email address, phone number (optional), message content and, for job applications, the attached CV. We do not use profiling cookies or third-party tracking tools." },
        { title: "3. Purposes and legal basis", text: "Data sent via the contact form is processed to respond to requests received. Data and CVs sent via the \"Work with us\" section are processed to evaluate applications. The legal basis is the data subject's consent (art. 6, par. 1, lett. a GDPR), given through the dedicated checkbox." },
        { title: "4. Data retention", text: "Contact data is kept for the time needed to handle the request. CVs are kept for a maximum of 24 months from submission, unless the data subject requests otherwise, and are then deleted." },
        { title: "5. Disclosure to third parties", text: "Data is never sold or transferred to third parties. It is processed exclusively by authorised cooperative staff and by technical providers (hosting and email services) operating in compliance with the GDPR." },
        { title: "6. Your rights", text: "You can exercise your rights under articles 15-22 of the GDPR (access, rectification, erasure, restriction, objection, portability) at any time by writing to cooperativafilia@gmail.com. You also have the right to lodge a complaint with the Italian Data Protection Authority (www.garanteprivacy.it)." },
      ],
    },
    footer: {
      title: "Let's talk.",
      sub: "For reports, collaborations or placement requests, write or call us: we will get back to you as soon as possible.",
      emailLabel: "Email",
      pecLabel: "PEC (certified email)",
      phoneLabel: "Phone",
      hqLabel: "Registered office",
      vatLabel: "VAT no.",
      vatValue: "10250451217",
      hqValue: "Via della Repubblica, 41 · 80010 Villaricca (NA), Italy",
      rights: "© 2026 Filia Società Cooperativa Sociale — All rights reserved",
      tagline: "Residential care for minors · Campania and Lazio",
    },
  },
};
